import { __read } from "tslib";
import React, { useState } from 'react';
import Measure from 'react-measure';
var ResponsiveWrapper = function (_a) {
    var children = _a.children, _b = _a.mountTreshold, mountTreshold = _b === void 0 ? 2 : _b;
    var _c = __read(useState(0), 2), resizeCount = _c[0], setResizeCount = _c[1];
    var _d = __read(useState({
        width: 0,
        height: 0,
    }), 2), dimensions = _d[0], setDimensions = _d[1];
    var width = dimensions.width, height = dimensions.height;
    var showContent = resizeCount >= mountTreshold && height > 0 && width > 0;
    return (React.createElement(Measure, { bounds: true, onResize: function (_a) {
            var bounds = _a.bounds;
            if (resizeCount <= 2) {
                setResizeCount(resizeCount + 1);
            }
            setDimensions({
                height: bounds.height,
                width: bounds.width,
            });
        } }, function (_a) {
        var measureRef = _a.measureRef;
        return (React.createElement("div", { ref: measureRef, style: {
                height: '100%',
                width: '100%',
                display: 'flex',
                minHeight: 0,
                minWidth: 0,
                position: 'relative',
            } }, showContent && children(width, height)));
    }));
};
export default ResponsiveWrapper;
